import { OrderWithDeliveryDateDeliveryStatus } from "@/generated/open-api/schemas";

export const orderDeliveryStatusLabels: Record<OrderWithDeliveryDateDeliveryStatus, string> = {
  [OrderWithDeliveryDateDeliveryStatus.None]: "配送準備中",
  [OrderWithDeliveryDateDeliveryStatus.PartlyShipped]: "出荷済み",
  [OrderWithDeliveryDateDeliveryStatus.Shipped]: "出荷済み",
  [OrderWithDeliveryDateDeliveryStatus.Cancel]: "キャンセル済み",
};
